import { Swiper, SwiperSlide } from "swiper/react"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHtml5, faCss3Alt, faSass, faReact, faGit, faJs, faNode, faSymfony, faAngular, faLaravel, faGithub, faDocker, faLinux } from '@fortawesome/free-brands-svg-icons'
import "swiper/css"
import '../sass/Swiper.scss'
import "swiper/css/navigation"
import "swiper/css/pagination"
import { Navigation, Pagination } from "swiper/modules"

const skills = [
    { label: 'HTML', icon: faHtml5, color: '#DD4B25' },
    { label: 'CSS', icon: faCss3Alt, color: '#3595CF' },
    { label: 'SASS', icon: faSass, color: '#C76395' },
    { label: 'JS', icon: faJs, color: '#E8D44D' },
    { label: 'REACT', icon: faReact, color: '#5ED3F3' },
    { label: 'GIT', icon: faGit, color: '#3F2E00' },
    { label: 'ANGULAR', icon: faAngular, color: '#bd002e' },
    { label: 'LARAVEL', icon: faLaravel, color: '#f72c1f' },
    { label: 'NODE JS', icon: faNode, color: '#7FC728' },
    { label: 'SYMFONY', icon: faSymfony, color: '#000000' },
    { label: 'CI/CD (Gitlab CI/Github Actions)', icon: faGithub, color: 'black' },
    { label: 'DOCKER', icon: faDocker, color: '#2391e6' },
    { label: 'LINUX', icon: faLinux, color: 'black' },
]

function Swipe() {
    return <div className="swiper" id="swiper">
        MES COMPETENCES :<br/><br/>
        <Swiper navigation={true} slidesPerView={1} loop={true}
            modules={[Navigation, Pagination]} pagination={{ dynamicBullets: true }} className="mySwiper">
            {skills.map(skill => (
                <SwiperSlide key={skill.label}>
                    <div className="techno_swiper">
                        <h1>{skill.label}</h1>
                        <br></br>
                        <FontAwesomeIcon icon={skill.icon} color={skill.color} size='5x'/>
                    </div>
                </SwiperSlide>
            ))}
        </Swiper>
        <br/>
        MES EXPERIENCES :
        <br/><br/>
    </div>
}
export default Swipe
